<template>
  <VOtpInput
    class="otp-input-group"
    :value="modelValue"
    :num-inputs="length"
    input-type="number"
    inputmode="numeric"
    :should-auto-focus="autofocus"
    :placeholder="placeholders"
    separator=""
    input-classes="otp-box"
    @update:value="(v: string) => emit('update:modelValue', v)"
    @on-complete="(v: string) => emit('complete', v)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import VOtpInput from 'vue3-otp-input'

const props = withDefaults(
  defineProps<{
    modelValue: string
    length?: number
    autofocus?: boolean
  }>(),
  {
    length: 6,
    autofocus: true,
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'complete', value: string): void
}>()

const placeholders = computed(() => Array(props.length).fill(''))
</script>

<style scoped>
.otp-input-group {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

/* vue3-otp-input renders raw inputs inside; reach them with :deep */
:deep(.otp-box) {
  width: 2.75rem;
  height: 3rem;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  -moz-appearance: textfield;
}

:deep(.otp-box::-webkit-outer-spin-button),
:deep(.otp-box::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

:deep(.otp-box:focus) {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.3);
}
</style>
